function f(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
export {
  f as default
};
//# sourceMappingURL=taggedTemplateLiteral.js.map
